import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor(){}

    setData(name, value){
        localStorage.setItem(name, value);
    }

    getData(name){
        return localStorage.getItem(name);
    }

    removeData(name){
        localStorage.removeItem(name);
    }

    clearStorage(){
        localStorage.clear();
    }
}